import { render, staticRenderFns } from "./CollisionModule.vue?vue&type=template&id=71689c74&scoped=true"
import script from "./CollisionModule.vue?vue&type=script&lang=js"
export * from "./CollisionModule.vue?vue&type=script&lang=js"
import style0 from "./CollisionModule.vue?vue&type=style&index=0&id=71689c74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71689c74",
  null
  
)

export default component.exports